"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var disaggregation_service_1 = require("./disaggregation.service");
var dynamic_forms_service_1 = require("./dynamic-forms-service");
var framework_service_1 = require("./framework.service");
var indicator_service_1 = require("./indicator.service");
var question_service_1 = require("./question.service");
var operators_1 = require("rxjs/operators");
var HttpCommonServicesProviderService = /** @class */ (function () {
    function HttpCommonServicesProviderService(indicatorService, frameworkService, disaggregationService, questionService, classifierService, currentLanguageProvider) {
        this.indicatorService = indicatorService;
        this.frameworkService = frameworkService;
        this.disaggregationService = disaggregationService;
        this.questionService = questionService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
    }
    HttpCommonServicesProviderService.prototype.getItemsBySystemName = function (systemName) {
        var _this = this;
        if (systemName === "Indicator") {
            return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.take(1), operators_1.switchMap(function (currentLanguage) {
                return _this.indicatorService.getIndicators().pipe(operators_1.map(function (indicators) {
                    return indicators.map(function (indicator) {
                        return {
                            id: indicator.id,
                            name: indicator.name[currentLanguage.getId()]
                        };
                    });
                }));
            }));
        }
        else if (systemName.startsWith("disaggregation_")) {
            var disaggregationId_1 = Number(systemName.substring(15));
            return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.take(1), operators_1.switchMap(function (currentLanguage) {
                return _this.disaggregationService.getDisaggregation(disaggregationId_1, currentLanguage.getId()).pipe(operators_1.map(function (value) {
                    return value.items.map(function (item) {
                        return {
                            id: item.id,
                            name: item.name.getValue(currentLanguage.getId())
                        };
                    });
                }));
            }));
        }
        else if (systemName === "Question") {
            return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.take(1), operators_1.switchMap(function (currentLanguage) {
                return _this.questionService.getQuestions().pipe(operators_1.map(function (questions) {
                    return questions.map(function (question) {
                        return {
                            id: question.id,
                            name: question.name.getValue(currentLanguage.getId())
                        };
                    });
                }));
            }));
        }
        else if (systemName.startsWith("RFLevel")) {
            var levelId_1 = Number(systemName.substring(7));
            return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.take(1), operators_1.switchMap(function (currentLanguage) {
                return _this.frameworkService.getRFItemsByLevel(levelId_1).pipe(operators_1.map(function (rfItems) {
                    return rfItems.map(function (rfItem) {
                        return {
                            id: rfItem.id,
                            name: rfItem.name[currentLanguage.getId()]
                        };
                    });
                }));
            }));
        }
        else {
            return this.classifierService.loadClassifiersView(systemName).pipe(operators_1.map(function (classifiers) {
                return classifiers.map(function (classifier) {
                    return {
                        id: classifier.getId(),
                        name: classifier.getName()
                    };
                });
            }));
        }
    };
    HttpCommonServicesProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [indicator_service_1.IndicatorService,
            framework_service_1.FrameworkService,
            disaggregation_service_1.DisaggregationService,
            question_service_1.QuestionService,
            dynamic_forms_service_1.HttpMEClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpCommonServicesProviderService);
    return HttpCommonServicesProviderService;
}());
exports.HttpCommonServicesProviderService = HttpCommonServicesProviderService;
//# sourceMappingURL=http-common-services-provider.service.js.map